import { useAppConstants } from "@/Hooks/useAppConstants";
import { GreenTick } from "../../../utils/svgIcons";

const PurchaseSuccessCTA = ({ handleManageDNS }) => {
  const {
    workspace: { sell_titan_email_free_with_domain },
  } = useAppConstants();

  return (
    <div className="tw-flex tw-w-fit tw-items-center tw-justify-center tw-gap-3 tw-bg-blue-two tw-px-[17px] tw-py-[14px] tw-font-jakarta">
      <GreenTick />
      <div>
        <span className="tw-text-[15px] tw-font-semibold tw-leading-8">
          Your domain is getting ready to be yours. It will be live in 30min.
        </span>
      </div>
      <div onClick={() => handleManageDNS()}>
        <span className="tw-cursor-pointer tw-text-[15px] tw-font-semibold tw-leading-5 tw-text-blue-three">
          Manage Domains {sell_titan_email_free_with_domain ? "& Email Accounts" : ""} here
        </span>
      </div>
    </div>
  );
};

export default PurchaseSuccessCTA;
